<template>
  <div style="padding: 2px 10px; margin: 3px auto; max-width: 800px">
    <Dropdown
      v-if="leagues && leagues.length > 1"
      v-model="currentLeague"
      :options="leagues"
      optionLabel="name"
      @change="currentLeagueChanged"
    />
    <Dropdown
      v-else
      style="width: 100%"
      v-model="currentLeague"
      :options="leagues"
      optionLabel="name"
      disabled
    />
  </div>
  <div
    v-if="userHasRole('SEASON_MANAGER') && currentLeague && currentLeague.id == 0"
    style="padding: 5px 10px; margin: 5px auto; max-width: 800px"
  >
    <InputText
      v-model="searchTextData"
      placeholder="Suchwert, z.B. Name eines Spielers, einer Mannschaft oder Liga"
      @input="executeSearch"
      style="min-width: 100%"
    />
    <div
      style="display: block; padding: 5px 1px; margin: 3px auto; max-width: 800px"
      v-show="searchResultContainers.length >= 1"
    >
      <div>
        <Accordion :activeIndex="activeIndex" style="padding-bottom: 20px">
          <AccordionTab
            v-for="searchResultContainer in searchResultContainers"
            v-bind:key="searchResultContainer.name"
            :header="
              searchResultContainer.name +
              '    (' +
              searchResultContainer.counterString +
              ')'
            "
          >
            <div
              style="text-align: left; margin: 5px 30px"
              v-for="searchResult in searchResultContainer.results"
              v-bind:key="searchResult.description"
            >
              <router-link
                :to="
                  '/recordview/' +
                  searchResultContainer.recordType +
                  '/' +
                  searchResult.id
                "
                >{{ searchResult.description }}</router-link
              >
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  </div>

  <div
    v-if="userHasRole('SEASON_MANAGER') && currentLeague && currentLeague.id == 0"
    style="display: block; padding: 5px 1px; margin: 5px auto; max-width: 1000px"
  >
    <AdminLatestGamesView :leagueId="currentLeague.id" />
  </div>
  <div
    v-if="
      userHasRole('LEAGUE_MAINTAINER') &&
      currentLeague &&
      currentLeague.id >= 0 &&
      currentLeague.type == 'REGULAR'
    "
    style="display: block; padding: 5px 1px; margin: 5px auto; max-width: 1000px"
  >
    <AdminGameDayView :league="currentLeague" />
  </div>
  <div
    v-if="
      userHasRole('LEAGUE_MAINTAINER') &&
      currentLeague &&
      currentLeague.id >= 0 &&
      currentLeague.type != 'CUP'
    "
    style="display: block; padding: 5px 1px; margin: 5px auto; max-width: 1000px"
  >
    <AdminConversationsView :leagueId="currentLeague.id" />
  </div>
  <div
    v-if="userHasRole('LEAGUE_MANAGER') && currentLeague && currentLeague.type == 'CUP'"
    style="display: block; padding: 5px 1px; margin: 0px auto; max-width: 1000px"
  >
    <CupAdminDashBoard
      :key="currentLeague.id"
      :leagueId="currentLeague.id"
      :cupLeagueMissing="currentLeague.id < 0"
      :cupScope="currentLeague.cupScope"
      @created="reloadLeagues"
    />
  </div>
</template>

<script>
import { useMenuService } from "../../services/MenuService/UseMenuService";
import UserPermissionsService from "../../services/UserPermissionsService/UserPermissionsService";
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../services/ServerConnection/FailureHandler";
import CupAdminDashBoard from "../cupadmin/CupAdminDashBoard.vue";
import AdminLatestGamesView from "./AdminLatestGamesView";
import AdminConversationsView from "./AdminConversationsView";
import AdminGameDayView from "./AdminGameDayView.vue";
import InputText from "primevue/inputtext";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Dropdown from "primevue/dropdown";
import { CUP_SCOPES } from "../cupadmin/cupScopes";
var searchTextExternal = "";
export default {
  name: "AdminDashBoard",
  components: {
    InputText,
    Accordion,
    AccordionTab,
    Dropdown,
    AdminLatestGamesView,
    AdminConversationsView,
    CupAdminDashBoard,
    AdminGameDayView,
  },
  data() {
    return {
      searchTextData: this.searchText ? this.searchText : searchTextExternal,
      searchTextQueue: [],
      searchResultContainers: [],
      activeIndex: -1,
      currentLeague: {},
      leagues: undefined,
    };
  },
  props: {
    searchText: {
      type: String,
      required: false,
    },
  },
  created() {
    this.searchTextData = "";
    this.updateMainMenu();
    this.loadLeagues();
    if (this.searchTextData && this.searchTextData.length > 1) {
      this.executeSearch();
    }
  },
  watch: {
    currentLeague() {
      this.updateMainMenu();
    },
  },
  methods: {
    loadLeagues(selectAbbreviation) {
      if (!this.leagues) {
        ServerConnection.get("admin/leagues")
          .then((response) => response.data)
          .then((dataList) => {
            this.leagues = dataList;
            this.addCupPlaceholderLeagues();
            if (this.leagues.length > 1) {
              this.leagues.unshift({
                id: 0,
                name: "Alle Ligen",
              });
              this.currentLeague = this.leagues[0];
            } else if (this.leagues.length == 1) {
              this.currentLeague = this.leagues[0];
            }
            var currentLeagueId = localStorage.getItem("currentLeagueId");
            if (currentLeagueId) {
              var matchingLeagues = this.leagues.filter((l) => l.id == currentLeagueId);
              if (matchingLeagues.length > 0) {
                this.currentLeague = matchingLeagues[0];
              }
            }
            if (selectAbbreviation) {
              var createdLeagues = this.leagues.filter(
                (l) => l.id > 0 && l.abbreviation == selectAbbreviation
              );
              if (createdLeagues.length > 0) {
                this.currentLeague = createdLeagues[0];
                this.currentLeagueChanged();
              }
            }
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    addCupPlaceholderLeagues() {
      if (!this.userHasRole("SEASON_MANAGER")) {
        return;
      }
      CUP_SCOPES.forEach((cupScope, index) => {
        var exists = this.leagues.some(
          (league) =>
            league.type == "CUP" &&
            league.abbreviation &&
            league.abbreviation.toLowerCase() == cupScope.abbreviation.toLowerCase()
        );
        if (!exists) {
          this.leagues.push({
            id: -(index + 1),
            name: cupScope.placeholderName,
            abbreviation: cupScope.abbreviation,
            cupScope: cupScope.scope,
            type: "CUP",
          });
        }
      });
    },
    reloadLeagues() {
      var placeholderAbbreviation =
        this.currentLeague && this.currentLeague.id < 0
          ? this.currentLeague.abbreviation
          : null;
      this.leagues = undefined;
      this.loadLeagues(placeholderAbbreviation);
    },
    currentLeagueChanged() {
      if (this.currentLeague) {
        localStorage.setItem("currentLeagueId", this.currentLeague.id);
      }
    },
    updateMainMenu() {
      const menuService = useMenuService();
      menuService.setMainMenuItemNames(["messages", "settings", "sidebar", "logout"]);
      var sidebarItems = [];
      if (this.userHasRole("SEASON_MANAGER")) {
        // {
        //   label: "Neue Mannschaft",
        //   icon: "pi pi-plus",
        //   command: () => {
        //     this.$router.push("/newrecord/team/");
        //   },
        // },
        sidebarItems.push({
          label: "Neuer Spielort",
          icon: "pi pi-plus",
          command: () => {
            this.$router.push("/newrecord/location/");
          },
        });
        sidebarItems.push({
          label: "Spieltage & Spiele",
          icon: "pi pi-calendar",
          command: () => {
            this.$router.push("/admin/gameandgameday");
          },
        });
        sidebarItems.push({
          label: "Spielorte zusammenführen",
          icon: "pi pi-link",
          command: () => {
            this.$router.push("/admin/locationmerge");
          },
        });
        sidebarItems.push({
          label: "Ansprechpartner zusammenführen",
          icon: "pi pi-link",
          command: () => {
            this.$router.push("/admin/contactpersonmerge");
          },
        });
      }
      if (this.userHasRole("SEASON_MANAGER")) {
        sidebarItems.push({
          label: "Übersicht verlegte Spiele",
          icon: "pi pi-plus",
          command: () => {
            this.$router.push("/postponedgames/" + this.currentLeague.id);
          },
        });
      }

      if (this.userHasRole("ADMIN")) {
        sidebarItems.push({
          label: "API-Schlüssel",
          icon: "pi pi-key",
          command: () => {
            this.$router.push("/admin/apikeys");
          },
        });
      }
      if (this.userHasRole("ADMIN") || this.userHasRole("USER_ADMIN")) {
        sidebarItems.push({
          label: "Mailversand",
          icon: "pi pi-envelope",
          command: () => {
            this.$router.push("/admin/maillog");
          },
        });
      }
      if (this.userHasRole("USER_ADMIN")) {
        sidebarItems.push({
          label: "Benutzerverwaltung",
          icon: "pi pi-users",
          command: () => {
            this.$router.push("/usermanagement");
          },
        });
        if (!this.userHasRole("SEASON_MANAGER")) {
          sidebarItems.push({
            label: "Ansprechpartner zusammenführen",
            icon: "pi pi-link",
            command: () => {
              this.$router.push("/admin/contactpersonmerge");
            },
          });
        }
      }
      if (this.userHasRole("PRESEASON_MANAGER")) {
        sidebarItems.push({
          label: "Spielplanverwaltung",
          icon: "pi pi-calendar",
          command: () => {
            this.$router.push("/seasonscheduler");
          },
        });
      }

      menuService.setSidebarItems(sidebarItems);
    },
    executeSearch() {
      this.activeIndex = null;
      this.searchResultContainers = [];
      if (this.searchTextData && this.searchTextData != "") {
        searchTextExternal = this.searchTextData;
        ServerConnection.get("admin/search", {
          params: {
            leagueId: this.currentLeague.id,
            searchText: this.searchTextData,
          },
        })
          .then((response) => response.data)
          .then((dataList) => {
            this.addSearchResult(dataList);
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    addSearchResult(dataList) {
      this.searchResultContainers = [];
      dataList.forEach((data) => {
        if (data.searchItems.length > 0) {
          this.searchResultContainers.push({
            name: data.recordDisplayName,
            recordType: data.recordType,
            results: data.searchItems,
            counterString:
              data.searchItems.length + (data.seachResultExeceedsMaxCount ? "+" : ""),
          });
        }
      });
      if (
        this.searchResultContainers.length > 0 &&
        this.searchResultContainers.length < 2
      ) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = undefined;
      }
    },
    userHasRole(role) {
      return UserPermissionsService.userHasRole(role);
    },
  },
};
</script>

<style>
.p-overlay-badge .p-badge {
  transform: translate(0%, -25%);
}
</style>
